
// Survey
export const GET_SURVEY = "GET_SURVEY"
export const ACTIVATE_STEP = "ACTIVATE_STEP"

// Answer - Result
export const UPDATE_ANS = "UPDATE_ANS"
export const UPDATE_USER = "UPDATE_USER"

export const CLEAR_ANS = "CLEAR_ANS"
export const SET_ANS = "SET_ANS"
export const SET_DIRECTION = "SET_DIRECTION"
export const SET_DIMENSION = "SET_DIMENSION"
export const SET_SURVEY_ID = "SET_SURVEY_ID"
export const UPDATE_RESULT_ID = "UPDATE_RESULT_ID"

// Result
export const GET_RESULT = "GET_RESULT"

// UI reducer types
export const SET_ERRORS = 'SET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const STOP_LOADING_UI = 'STOP_LOADING_UI';
